//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import Mixpanel from "./analyticsLoggers/MixpanelLogger.js";

const allLoggers = {
  mixpanel: Mixpanel,
};

class _analyticsLogger {
  constructor() {
    this.store = null;
    this.product_tag = null;
    this.trackEvents = true;
  }

  async init(config, store, product_tag = null, shouldTrackEvents = true) {
    this.store = store;
    this.product_tag = product_tag;
    this.trackEvents = shouldTrackEvents;

    if (
      (config.appConfig.env === "local" &&
        !config.appConfig.analytics_provider.token) ||
      new URLSearchParams(window.location.search).has("debug")
    ) {
      this.logger = console;
      return;
    }

    if (!this.trackEvents) {
      return;
    }

    try {
      this.logger = new allLoggers[
        config.appConfig.analytics_provider.type.toLowerCase()
      ](this.store);
      const provider = config.appConfig.analytics_provider;
      const initOptions = provider.api_host ? { api_host: provider.api_host } : {};
      await this.logger.init(provider.token, initOptions);
      delete config.appConfig.analytics_provider["token"];
    } catch (ex) {
      this.logger = allLoggers.general;
      console.warn(
        `${config.appConfig.analytics_provider.type} failed to init, ${ex}`
      );
    }
  }

  log(event, product_tag = null) {
    if ((!this.trackEvents && !this.logger) || !event) {
      return;
    }
    product_tag = !product_tag ? this.product_tag : product_tag;
    event = {
      ...event,
      ...this.store.state.Session,
      product_tag: product_tag,
    };
    try {
      this.logger.log(event.title, event);
    } catch (ex) {
      //TODO log to error logger
      console.log("Analytics tracker not working", ex);
    }
  }
}
const AnalyticsLogger = new _analyticsLogger();
export default AnalyticsLogger;
